import * as Yup from 'yup';
import { REQUIRED_FIELD } from '../../../../constants';

export const TenantValidationSchema = Yup.object().shape({
  name: Yup.string().required(REQUIRED_FIELD),
});
